import { useLocation } from 'react-router-dom';
import { useEffect, useState } from 'react';

const LIST_PATHS = [
	'/.*/list',
	'/.*/list_new',
	'/.*/loglist',
	'/savedfilter/mylist',
	'/savedfilter/systemlist',
	'/savedfilter/otherlist',
	'/savedfilter/logslist',
	'/activity/tasklist',
	'/employercontactperson/list',
	'/employer/list_old',
	'/candidate/list_old',
	'/agency/list_old',
	'/fsapilog/loglist',
	'/document/documentsettinglist',
	'/surveyadmin/listoptout',
	'/contract/bulkupdaterequestlist',
];

function matchesListPathName(pathname) {
	const pathnameToLowerCase = pathname.toLowerCase();

	return LIST_PATHS.some((pattern) => {
		if (pattern.includes('.*')) {
			const regex = new RegExp(pattern);

			return regex.test(pathnameToLowerCase);
		}

		return pattern === pathnameToLowerCase;
	});
}

function useIsListPage() {
	const { pathname } = useLocation();
	const [isListPage, setIsListPage] = useState(false);

	useEffect(() => {
		setIsListPage(matchesListPathName(pathname));
	}, [pathname]);

	return isListPage;
}

export { matchesListPathName, useIsListPage };
